import { clsx } from 'clsx';
import dynamic from 'next/dynamic';
import { FC } from 'react';
import { H2 } from 'atoms/Typography';
import { useMediaQuery } from 'modules/mui/hooks';
import { useRouter } from 'modules/next/hooks';
import { TOTAL_STEPS, useGiftFinderStore } from '../../Finders/store';
import { MainCategoryItemsProps } from '../../Finders/types';
import styles from './styles.module.css';

const SubCategoryItems = dynamic(
  () => import('../../Finders/FinderWizard/SubCategoryItems'),
);

const combineFilterValues = (...allFilters: string[]) => {
  const combined = new URLSearchParams();
  allFilters.forEach((filter) => {
    if (!filter) {
      return;
    }
    const searchParams = new URLSearchParams(filter);
    searchParams.forEach((val, key) => combined.append(key, val));
  });
  return combined.toString();
};

export const MainCategoryItem: FC<
  MainCategoryItemsProps & { filterValue?: string }
> = ({
  isActive,
  backgroundColor,
  image,
  title,
  index,
  subCategories,
  filterValue,
  blockData,
  blockColor,
}) => {
  const { isMobile } = useMediaQuery();
  const router = useRouter();
  const {
    currentStep,
    activeItemIndex,
    selectedFilters,
    setActiveItemIndex,
    setSelectedFilter,
    setCurrentStep,
  } = useGiftFinderStore();

  const getBackgroundStyles = () => ({
    backgroundColor,
    left: !isActive && !isMobile ? `${index * 20}%` : '',
  });

  const handleSubCategoryClick = (
    subFilterValue?: string,
    isLastStep?: boolean,
  ) => {
    if (subFilterValue) {
      setSelectedFilter(currentStep, subFilterValue);
    }

    if (!isLastStep) {
      setCurrentStep(currentStep + 1);
    } else {
      const filtersArray = [...Object.values(selectedFilters)];
      if (subFilterValue) {
        filtersArray.push(subFilterValue);
      }

      const finalQuery = combineFilterValues(...filtersArray);
      router.push(`?${finalQuery}`);
    }
  };

  const handleMainCategoryClick = () => {
    if (activeItemIndex !== index) {
      setSelectedFilter(1, filterValue || '');
      setActiveItemIndex(index);
      setCurrentStep(2);
    }
  };

  const { priceCategoryItems, priceCategoryTitle, subCategoryTitle } =
    blockData;

  return (
    <div
      className={clsx(styles.inquiryItem, isActive && styles.isActive)}
      style={getBackgroundStyles()}
      onClick={handleMainCategoryClick}
    >
      <div
        style={{ backgroundImage: `url(${image})` }}
        className={styles.inquiryBackground}
      />
      <div className={styles.inquiryIntro}>
        <H2 className={styles.headline}>{title}</H2>
      </div>
      <div
        className={styles.inquiryQuestionWrapper}
        style={{ left: `-${(currentStep - 2) * 100}%` }}
      >
        {isActive && (
          <SubCategoryItems
            items={subCategories}
            question={subCategoryTitle}
            onAnswerClick={({ filterValue }) =>
              handleSubCategoryClick(filterValue, false)
            }
          />
        )}
        {isActive && currentStep === TOTAL_STEPS.at(-1) && (
          <SubCategoryItems
            items={priceCategoryItems}
            question={priceCategoryTitle}
            onAnswerClick={({ filterValue }) =>
              handleSubCategoryClick(filterValue, true)
            }
            isPriceBlock
            blockColor={blockColor}
          />
        )}
      </div>
    </div>
  );
};
